import styled from "styled-components";

export const Description = styled.p`
  padding-bottom: .5rem;
`;
